export default ({
  message,
  code = 'algolia',
  event = 'click',
  extraData = {}
} = {}) => {
  window.analytics.track(message, {
    code: `doc.${code}.${event}`,
    path: window.location.pathname,
    url: window.location.href,
    title: document.title,
    extraData
  })
}
